import { AlertTriangle, X } from "lucide-react";

export default function ConfirmDialog({
  open,
  title = "Confirmar",
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  tone = "danger", // "danger" | "primary"
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  const bg =
    tone === "danger"
      ? "bg-rose-600 hover:bg-rose-700"
      : "bg-blue-600 hover:bg-blue-700";
  const iconBg =
    tone === "danger" ? "bg-rose-50 text-rose-600" : "bg-blue-50 text-blue-600";

  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
      data-testid="confirm-dialog"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
          <h3 className="font-heading font-bold text-slate-900">{title}</h3>
          <button onClick={onCancel} className="p-1 rounded-md hover:bg-slate-100">
            <X className="w-4 h-4 text-slate-400" />
          </button>
        </div>
        <div className="p-5 flex gap-3">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${iconBg}`}>
            <AlertTriangle className="w-5 h-5" />
          </div>
          <p className="text-sm text-slate-700 leading-relaxed pt-1.5">{message}</p>
        </div>
        <div className="px-5 py-3 border-t border-slate-100 bg-slate-50 flex justify-end gap-2">
          <button
            onClick={onCancel}
            data-testid="confirm-cancel"
            className="h-9 px-4 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-200"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            data-testid="confirm-ok"
            className={`h-9 px-4 rounded-lg text-sm font-semibold text-white ${bg}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
